import { render, staticRenderFns } from "./WorkflowDescriptionTooltip.vue?vue&type=template&id=81888236&scoped=true"
import script from "./WorkflowDescriptionTooltip.vue?vue&type=script&lang=js"
export * from "./WorkflowDescriptionTooltip.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDescriptionTooltip.vue?vue&type=style&index=0&id=81888236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81888236",
  null
  
)

export default component.exports